<template>
	<errorContainer :error="erreur" :warning="warning">
		<transition name="slide">
			<div :class="`${$screen.width <= 576 ? 'container-mobile' : ''}`">
				<!-- <b-row>
					<b-col sm="12">
						<h1 :class="`${!$screen.sm ? 'main-page-title' : ''}`">
							{{ FormMSG(1, 'Validate document') }}
						</h1>
					</b-col>
				</b-row> -->
				<b-row>
					<b-col class="p-3">
						<b-card>
							<b-card-text>
								<follow-up
									ref="document-follow-up"
									:follow-ups-list="followUps"
									:is-busy="isBusy"
									for-validation
									@follow-up:validate-document="handleFolloUpValidateDocument"
									@follow-up:document-signed="handleFollowUpDocumentSigned"
									@follow-up:document-refused="handleFollowUpDocumentRefused"
								/>
							</b-card-text>
						</b-card>
					</b-col>
				</b-row>
			</div>
		</transition>
	</errorContainer>
</template>

<script>
import FollowUp from '@/modules/onboarding/components/FollowUp';
import languageMessages from '@/mixins/languageMessages';
import { getDocumentToValidate } from '@/modules/onboarding/cruds/onboarding.crud';
import globalMixin from '@/mixins/global.mixin';
import { store } from '@/store';
import { mapActions } from 'vuex';
import { DOCUMENT_DELIVERY_STATUS } from '@/shared/constants';
import { getImgCommentList } from '@/cruds/images.crud';

export default {
	name: 'ValidateDocuments',
	components: {
		FollowUp
	},
	mixins: [languageMessages, globalMixin],
	data() {
		return {
			hv: 'dark',
			erreur: {},
			warning: '',
			followUps: [],
			isBusy: false
		};
	},
	async created() {
		if (store.getToken()) await this.getFollowUpsList();
	},
	methods: {
		...mapActions({
			getNotifications: 'header/getNotifications'
		}),
		async handleFollowUpDocumentRefused() {
			await this.getFollowUpsList();
		},
		async handleFollowUpDocumentSigned(payload) {
			await this.getFollowUpsList();
		},
		async handleFolloUpValidateDocument(payload) {
			await this.getFollowUpsList();
		},
		async getFollowUpsList() {
			this.isBusy = true;
			await this.getNotifications();
			const result = await getDocumentToValidate();
			for (const doc of result) {
				// fetch comments on refused documents.
				if (
					doc.senderStatus === DOCUMENT_DELIVERY_STATUS.REFUSED ||
					(doc.senderStatus === DOCUMENT_DELIVERY_STATUS.RECEIVED && doc.documentStatus === DOCUMENT_DELIVERY_STATUS.REFUSED)
				) {
					let comments = await getImgCommentList(doc.documentXid, doc.documentDeliveryId);
					let highestIdComment = comments.reduce((highestComment, currentComment) => {
						// Parse the IDs before comparison
						const highestCommentId = parseInt(highestComment.id, 10);
						const currentCommentId = parseInt(currentComment.id, 10);

						// Compare the parsed IDs
						return currentCommentId > highestCommentId ? currentComment : highestComment;
					}, comments[0]); // Initialize with the first comment

					doc.comments = highestIdComment && highestIdComment.message && !_.isEmpty(highestIdComment.message) ? highestIdComment.message : '';
				} else doc.comments = '';
			}
			this.followUps = result;
			this.isBusy = false;
		}
	}
};
</script>
